import KlantOverzicht from "components/Tables/CustomerOverzicht";

const Contacts = () => {
    return (
        <>
            {/* <h1>Klanten</h1> */}
            <KlantOverzicht />
        </>
    )
}

export default Contacts;